import Logger from "../common/utils/Logger";

export enum GameID {
    //--Batch1
    B1_Level11,
    B1_Level12,
    B1_Level13,
    B1_Level14,
    B1_Level15,
    B1_Loading1,
    B1_Loading2,
    B1_Loading3,
    B1_Loading4,
    B1_Loading5,
    B1_LVLTLoading1,
    B1_LVLTLoading2,
    B1_LVLTLoading3,
    B1_LVLTLoading4,
    B1_LVLTLoading5,
    B1_LVLTLoading6,
    B1_Hauling1,
    B1_Hauling2,
    B1_Hauling3,
    B1_Hauling4,
    B1_Hauling5,
    B1_Hauling6,
    B1_Grading1,
    B1_Grading2,
    B1_LVLTDisposal1,
    B1_LVLTDisposal2,
    B1_LVLTDisposal3,
    B1_LVLTDisposal4,
    B1_LVLTDisposal5,
    B1_LVLTDisposal6,
    B1_Disposal1,
    B1_Disposal2,
    B1_Disposal3,
    B1_Disposal4,
    B1_Disposal5,
    B1_Disposal6,
    B1_Disposal7,
    B1_Disposal8,
    B1_Production1,
    B1_Production2,
    B1_Production3,

    //Batch 2
    B2_Blasting1,
    B2_Blasting2,
    B2_CoalHandling1,
    B2_CoalHandling2,
    B2_CoalHandling3,
    B2_CoalHandling4,
    B2_CoalHandling5,
    B2_CoalHandling6,
    B2_CoalHandling7,
    B2_CoalHandling8,
    B2_CoalHandling9,
    B2_Crusher1,
    B2_Crusher2,
    B2_Crusher3,
    B2_Crusher4,
    B2_Crusher5,
    B2_Crusher6,
    B2_Crusher7,
    B2_Crusher8,
    B2_Crusher9,
    B2_Crusher10,
    B2_Crusher11,
    B2_Crusher12,
    B2_Crusher13,
    B2_Crusher14,
    B2_DraftSurvey1,
    B2_DraftSurvey2,
    B2_DraftSurvey3,
    B2_DraftSurvey4,
    B2_DraftSurvey5,
    B2_DraftSurvey6,
    B2_DraftSurvey7,
    B2_DraftSurvey8,
    B2_Drilling1,
    B2_Drilling2,
    B2_Drilling3,
    B2_Drilling4,
    B2_Drilling5,
    B2_Drilling6,
    B2_Escorting4,
    B2_Escorting5,
    B2_Escorting6,
    B2_FrontLoading1,
    B2_FrontLoading2,
    B2_FrontLoading3,
    B2_FrontLoading4,
    B2_FrontLoading5,
    B2_FrontLoading6,
    B2_FrontLoading7,
    B2_Hauling1,
    B2_Hauling2,
    B2_Hauling3,
    B2_Hauling4,
    B2_Hauling5,
    B2_Hauling6,
    B2_Hauling7,
    B2_Hauling8,
    B2_LandClearing1,
    B2_LandClearing2,
    B2_LandClearing3,
    B2_LandClearing4,
    B2_LandClearing5,
    B2_LandClearing6,
    B2_LandClearing7,
    B2_RoadWatering1,
    B2_RoadWatering2,
    B2_RoadWatering3,
    B2_RoadWatering4,
    B2_RoadWatering5,
    B2_MudHandling1,
    B2_MudHandling2,
    B2_MudHandling3,
    B2_MudHandling4,
    B2_MudHandling5,
    B2_SOLU1,
    B2_SOLU2,
    B2_SOLU3,
    B2_CoalBlending1,
    B2_CoalBlending2,
    B2_CoalBlending3,
    B2_Stockpile1,
    B2_Stockpile2,
    B2_Stockpile3,
    B2_Stockpile4,
    B2_Stockpile5,
    B2_Dewatering1,
    B2_Dewatering2,
    B2_Dewatering3,
    B2_Dewatering4,
    B2_Dewatering5,
    B2_Dewatering6,
    B2_MineWaterTreatment1,
    B2_MineWaterTreatment2,
    B2_MineWaterTreatment3,
    B2_MineWaterTreatment4,
    B2_MineWaterTreatment5,
    B2_MineWaterTreatment6,
    B2_MineWaterTreatment7,
}

export const GameIDStrings = [
    //--Batch1
    "Level 1-1",
    "Level 1-2",
    "Level 1-3",
    "Level 1-4",
    "Level 1-5",
    "Loading 1",
    "Loading 2",
    "Loading 3",
    "Loading 4",
    "Loading 5",
    "LVLT Loading 1",
    "LVLT Loading 2",
    "LVLT Loading 3",
    "LVLT Loading 4",
    "LVLT Loading 5",
    "LVLT Loading 6",
    "Hauling 1",
    "Hauling 2",
    "Hauling 3",
    "Hauling 4",
    "Hauling 5",
    "Hauling 6",
    "Grading 1",
    "Grading 2",
    "LVLT Disposal 1",
    "LVLT Disposal 2",
    "LVLT Disposal 3",
    "LVLT Disposal 4",
    "LVLT Disposal 5",
    "LVLT Disposal 6",
    "Disposal 1",
    "Disposal 2",
    "Disposal 3",
    "Disposal 4",
    "Disposal 5",
    "Disposal 6",
    "Disposal 7",
    "Disposal 8",
    "Production 1",
    "Production 2",
    "Production 3",

    //--Batch2
    "Blasting 1",
    "Blasting 2",
    "Coal Handling 1",
    "Coal Handling 2",
    "Coal Handling 3",
    "Coal Handling 4",
    "Coal Handling 5",
    "Coal Handling 6",
    "Coal Handling 7",
    "Coal Handling 8",
    "Coal Handling 9",
    "Crusher 1",
    "Crusher 2",
    "Crusher 3",
    "Crusher 4",
    "Crusher 5",
    "Crusher 6",
    "Crusher 7",
    "Crusher 8",
    "Crusher 9",
    "Crusher 10",
    "Crusher 11",
    "Crusher 12",
    "Crusher 13",
    "Crusher 14",
    "Draft Survey 1",
    "Draft Survey 2",
    "Draft Survey 3",
    "Draft Survey 4",
    "Draft Survey 5",
    "Draft Survey 6",
    "Draft Survey 7",
    "Draft Survey 8",
    "Drilling 1",
    "Drilling 2",
    "Drilling 3",
    "Drilling 4",
    "Drilling 5",
    "Drilling 6",
    "Escorting 4",
    "Escorting 5",
    "Escorting 6",
    "Front Loading 1",
    "Front Loading 2",
    "Front Loading 3",
    "Front Loading 4",
    "Front Loading 5",
    "Front Loading 6",
    "Front Loading 7",
    "Hauling 1",
    "Hauling 2",
    "Hauling 3",
    "Hauling 4",
    "Hauling 5",
    "Hauling 6",
    "Hauling 7",
    "Hauling 8",
    "Land Clearing 1",
    "Land Clearing 2",
    "Land Clearing 3",
    "Land Clearing 4",
    "Land Clearing 5",
    "Land Clearing 6",
    "Land Clearing 7",
    "Road Watering 1",
    "Road Watering 2",
    "Road Watering 3",
    "Road Watering 4",
    "Road Watering 5",
    "Mud Handling 1",
    "Mud Handling 2",
    "Mud Handling 3",
    "Mud Handling 4",
    "Mud Handling 5",
    "SOLU 1",
    "SOLU 2",
    "SOLU 3",
    "Coal Blending 1",
    "Coal Blending 2",
    "Coal Blending 3",
    "Stockpile 1",
    "Stockpile 2",
    "Stockpile 3",
    "Stockpile 4",
    "Stockpile 5",
    "Dewatering 1",
    "Dewatering 2",
    "Dewatering 3",
    "Dewatering 4",
    "Dewatering 5",
    "Dewatering 6",
    "MineWater Treatment 1",
    "MineWater Treatment 2",
    "MineWater Treatment 3",
    "MineWater Treatment 4",
    "MineWater Treatment 5",
    "MineWater Treatment 6",
    "MineWater Treatment 7",
];

export const GameIDs: GameID[] = <GameID[]>Object.values(GameID).filter(e => typeof e != 'string');